<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card :title="'Manage My Vehicles'">
      <template slot="actions">
        <vs-button
          class="mr-2 mt-2 m-auto gradient-btn"
          @click.prevent="vehicleBook =! vehicleBook"
          v-if="vehicle_list_tab != 1"
        >Book Vehicle</vs-button>
      </template>
      <form class="w-full" v-if="vehicleBook" autocomplete="off" data-vv-scope="book-form">
        <div class="vx-row mb-2">
          <h4 class="ml-5 mb-5">Book Vehicle</h4>
        </div>
        <div class="vx-row">
          <!-- <div class="vx-col md:w-1/1 form-group w-full">
          <div class="vx-row">-->

          <!-- <div class="vx-col md:w-1/4 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="Office"
              name="office_id"
              v-model="office_id"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.office_name"
                v-for="(item,index) in offices"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('book-form.office_id') }}</span>
          </div>-->

          <!-- </div>
          </div>-->
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="Office"
              name="office_id"
              v-model="office_id"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.office_name"
                v-for="(item,index) in offices"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('book-form.office_id') }}</span>
          </div>

          <div class="vx-col md:w-1/3 form-group w-full">
            <label for class="vs-input--label">Start Date</label>
            <flat-pickr
              :config="configFromdateTimePicker"
              @on-change="onFromChange"
              class="vs-inputx vs-input--input normal time"
              label="Start Date"
              v-validate="'required'"
              name="from_date"
              v-model="from_date"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('book-form.from_date') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <label for class="vs-input--label">Start Time</label>
            <flat-pickr
              :config="configdateTimePicker"
              class="vs-inputx vs-input--input normal time"
              v-validate="'required'"
              v-model="start_time"
              autocomplete="off"
              name="start_time"
            />
            <span class="text-danger text-sm">{{ errors.first('book-form.start_time') }}</span>
          </div>

          <div class="vx-col md:w-1/3 form-group w-full">
            <label for class="vs-input--label">End Date</label>
            <flat-pickr
              :config="configTodateTimePicker"
              class="vs-inputx vs-input--input normal time"
              label="End Date"
              v-validate="'required'"
              name="end_date"
              v-model="end_date"
              autocomplete="off"
              @on-change="onToChange"
            />
            <span class="text-danger text-sm">{{ errors.first('book-form.end_date') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <label for class="vs-input--label">End Time</label>
            <flat-pickr
              :config="configdateTimePicker"
              class="vs-inputx vs-input--input normal time"
              v-validate="'required'"
              v-model="end_time"
              autocomplete="off"
              name="end_time"
            />
            <span class="text-danger text-sm">{{ errors.first('book-form.end_time') }}</span>
          </div>
        </div>
        <div class="vx-row mb-5 mt-5">
          <div class="vx-col w-full">
            <vs-button
              class="mt-1 m-auto gradient-btn"
              @click.prevent="searchVehicle()"
              :disabled="button_loading"
              id="vehicle-addupdate"
            >Search</vs-button>
            <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelBook()">Cancel</vs-button>
          </div>
        </div>
      </form>
      <div class="mt-5 mb-5"  v-show="availableVehicle.length != 0">
        <vs-table
          :data="availableVehicle"
          pagination
          max-items="10"
        >
          <template slot="thead">
            <vs-th>Vehicle Number</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.number }}</vs-td>
              <vs-td>
                <vs-button
                  color="danger"
                  type="filled"
                  size="small"
                  title="Book Vehicle"
                  @click.prevent="confirmBook(data[indextr].id)"
                >Book</vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <!-- My vehicles -> Booked Vehicles & My history -->
      <vs-tabs v-model="vehicle_list_tab" :value="tabvalue" alignment="fixed">
        <vs-tab label="Booked Vehicles"  @click.prevent="vehicleBook = false">
          <div class="tab-text">
            <form class="vs-row mt-6 mb-3 w-full inline-block" autocomplete="off">
              <div class="vx-col md:w-1/4 float-left">
                  <v-select class="w-full" v-model="filter_office_id" :options="offices" label="office_name" index="id" placeholder="Select Office" />
              </div>
              <!-- <div class="vx-col md:w-1/4 float-right">
                  <vs-input class="w-full" icon-pack="feather" icon="icon-search" name="search" v-model="search" placeholder="Search Vehicle" autocomplete="off" />
              </div> -->
            </form>
            <div class="mt-5 mb-5">
              <vs-table :data="booked">
                <template slot="thead">
                  <vs-th>ID</vs-th>
                  <vs-th>Vehicle</vs-th>
                  <vs-th>Registration #</vs-th>
                  <vs-th>Office</vs-th>
                  <vs-th>Booked Date</vs-th>
                  <vs-th>Booked Time</vs-th>
                  <!-- <vs-th>Status</vs-th> -->
                  <vs-th>Unbook</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.vehical_id.vehical_id }}</vs-td>
                    <vs-td>{{ tr.vehical_id.name }} {{ tr.vehical_id.brand }}</vs-td>
                    <vs-td>{{ tr.vehical_id ? tr.vehical_id.number: '-' }}</vs-td>
                    <vs-td>{{ tr.office_id && tr.office_id.office_name ? tr.office_id.office_name : '-'}}</vs-td>
                    <vs-td>
                      <span v-if="tr.from_date == tr.to_date">{{ tr.from_date }}</span>
                      <span v-else>{{ tr.from_date }} - {{ tr.to_date }}</span>
                    </vs-td>
                    <vs-td>{{ tr.from_time }} - {{ tr.to_time}}</vs-td>
                    <!-- <vs-td>
                      <span v-if="tr.status == 'BO'">Booked</span>
                      <span v-else-if="tr.status == 'CO'">Completed</span>
                      <span v-else-if="tr.status == 'IU'">In Use</span>
                      <span v-else-if="tr.status == 'BD'">Break Down</span>
                      <span v-else-if="tr.status == 'UB'">Unbooked</span>
                      <span v-else></span>
                      - {{tr.user_id.firstname | capitalize}} {{tr.user_id.lastname.charAt(0) | capitalize}}
                    </vs-td> -->
                    <vs-td>
                      <vs-button
                        color="danger"
                        type="filled"
                        size="small"
                        title="Unbook Vehicle"
                        @click.stop="unbook(data[indextr].id)"
                        name="unbook_btn"
                        :disabled="tr.status !== 'BO'"
                      >Unbook</vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-tab>
        <!-- My History -->
        <vs-tab label="My History"  @click.prevent="vehicleBook = false">
          <div class="tab-text">
            <timesheet-history></timesheet-history>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import timeZone from "@/mixins/timezone.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import VueJsonToCsv from "vue-json-to-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import vSelect from "vue-select";
import TimesheetHistory from '@/components/vehicle/user/timesheet-history.vue';

//Validator.updateDictionary(dictionary);

const dict = {
  custom: {
    vehicle_id: {
      max: "Vehicle ID should not be greater than 5 characters",
      alpha_num: "Only alphanumeric value is allowed"
    },
    office_id: {
      required: "Please select office"
    },
    dept_id: {
      required: "Please select department"
    },
    name: {
      required: "Please enter name",
      max: "Vehicle make should not be greater than 25 characters",
      alpha_num: "Only alphanumeric value is allowed"
    },
    vehicle_number: {
      required: "Please enter vehicle number",
      max: "Vehicle number should not be greater than 10 characters",
      alpha_num: "Only alphanumeric value is allowed"
    },
    starting_kms: {
      required: "Please enter starting kms",
      decimal:
        "Starting Kms should be numeric and may contain 2 decimal points",
      max: "Starting Kms should not be greater than 8 digits"
    },
    from_date: {
      required: "Please select start date"
    },
    start_time: {
      required: "Please select start time"
    },
    end_date: {
      required: "Please select end date"
    },
    end_time: {
      required: "Please select end time"
    },
    vehicle_year: {
      required: "Please enter vehicle year",
      max: "Vehicle year should not be greater than 4 digits",
      alpha_num: "Only alphanumeric value is allowed",
      between: "Year must be between 2000-" + new Date().getFullYear()
    },
    type: {
      max: "type name should not be greater than 25 characters",
      alpha_num: "Only alphanumeric value is allowed"
    },
    colour: {
      max: "colour name should not be greater than 25 characters",
      alpha_num: "Only alphanumeric value is allowed"
    },
    brand: {
      max: "Vehicle model should not be greater than 25 characters",
      alpha_num: "Only alphanumeric value is allowed"
    }
  }
};
// register custom messages
Validator.localize("en", dict);

export default {
  components: {
    Datepicker,
    jsPDF,
    VueJsonToCsv,
    vSelect,
    TimesheetHistory
  },
  data() {
    return {
      vehicle_list_tab: 0,
      booked_btn: true,
      show_v_type: true,
      vehicle_id: null,
      is_disabled: false,
      v_id_type: "type",
      serviceDue: "kmmiles",
      receipts: [],
      vehicles: [],
      booked: [],
      currentYear: new Date().getFullYear(),
      offices: [],
      deleteIndex: 0,
      vehicleAddEdit: false,
      vehicleBook: false,
      availableVehicle: [],
      vehicleIndex: null,
      vehicle_name: null,
      office_id: null,
      rego_next_date: null,
      starting_kms: null,
      vehicle_number: null,
      service_due_date: null,
      vehicleDetailPopup: false,
      vehicleViewData: [],
      status: "AV",
      name: null,
      tabvalue: 0,
      brand: null,
      dept_id: null,
      departments: [],
      vehicleID: null,
      year: null,
      type: null,
      colour: null,
      service_due_date: {
        kmmiles: null,
        date: null,
        month: null
      },
      disabledPastDates: {
        to: new Date(Date.now() - 8640000)
      },
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        dateFormat: "G:i K"
      },
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null,
        dateFormat: "d/m/Y"
      },
      configTodateTimePicker: {
        minDate: new Date(),
        dateFormat: "d/m/Y"
      },
      month: null,
      filter_office_id: null,
      start_time: null,
      from_date: null,
      end_time: null,
      end_date: null,
      status_arr: [
        {
          value: "AV",
          name: "Available"
        },
        {
          value: "BD",
          name: "Break Down"
        }
      ],
      types: [
        { value: "Sedan", name: "Sedan" },
        { value: "Pickup", name: "Pickup" },
        { value: "Wagon", name: "Wagon" },
        { value: "Ute", name: "Ute" },
        { value: "Van", name: "Van" }
      ],
      csvMyHistoryData: [
        {
          date: '',
          id: '',
          vehicle: '',
          odometer_start: '',
          odometer_end: '',
          odometer_total: '',
          time_start: '',
          time_end: '',
          time_total: '',
          fuel_odometer: '',
          fuel_volume: '',
          fuel_value: '',
          faults: ''
        }
      ]
    };
  },
  created() {
    // if (
    //   this.$store.state.uInfo.role !== "CA" &&
    //   this.$store.state.uInfo.role !== "HR"
    // ) {
    //   history.back();
    // }
  },
  mounted() {
    this.getOffice();
    this.getVechicle();
    this.vehiclebookedByme();
  },
  computed: {
    email_validate() {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    },
    check_start_end_time() {
      let start_t = this.start_time;
      let start_d = this.from_date;
      let end_d = this.end_date;
      let end_t = this.end_time;
    }
  },
  watch: {
    serviceDue(nv) {
      if (nv == "kmmiles") {
        this.service_due_date.date = null;
        this.service_due_date.month = null;
      } else {
        this.service_due_date.kmmiles = null;
      }
    },
    v_id_type(val) {
      if (val == "auto") {
        this.is_disabled = true;
        this.generateVid();
      } else {
        this.is_disabled = false;
        this.vehicle_id = "";
      }
    },
    filter_office_id(){
        this.vehiclebookedByme();
    }
  },

  methods: {
    // Generate and download my history pdf
    generateMyHistoryPDF() {
      const doc = new jsPDF();
      var finalY = doc.lastAutoTable.finalY || 10;
      doc.text("My History", 14, finalY + 15);
      doc.autoTable({
        body: this.csvMyHistoryData,
        startY: finalY + 20,
        columns: [
          { header: "Date", dataKey: "date" },
          { header: "Id", dataKey: "id" },
          { header: "Vehicle", dataKey: "vehicle" },
          { header: "Odometer Start", dataKey: "odometer_start" },
          { header: "Odometer End", dataKey: "odometer_end" },
          { header: "Odometer Total", dataKey: "odometer_total" },
          { header: "Time Start", dataKey: "time_start" },
          { header: "Time End", dataKey: "time_end" },
          { header: "Time Total", dataKey: "time_total" },
          { header: "Fuel Odometer", dataKey: "fuel_odometer" },
          { header: "Fuel Volume", dataKey: "fuel_volume" },
          { header: "Fuel Value", dataKey: "fuel_value" },
          { header: "Faults", dataKey: "faults" },
        ]
      });
      doc.save("DaysData.pdf");
    },
    generateVid() {
      var length = 5;

      var text = "";
      var possible = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      this.vehicle_id = text;
    },
    endTimeCheck() {
      let start = moment(this.start_time, ["h:mm A"]).format("HH:mm");
      let end = moment(this.end_time, ["h:mm A"]).format("HH:mm");
      if (end < start) {
        this.$vs.notify({
          text: "End time should exceed the start time",
          position: "top-right",
          color: "danger"
        });
        return false;
      } else if (end == start) {
        this.$vs.notify({
          text: "Start time and end time cannot be same",
          position: "top-right",
          color: "danger"
        });
        return false;
      }
    },
    changeOffice() {
      if (this.filter_office_id == "all") {
        this.getVechicle();
      } else {
        this.$vs.loading({ color: "primary" });
        let url = "vehicals?office_id=" + this.filter_office_id;
        this.axios
          .get(url)
          .then(response => {
            let data = response.data.data;
            this.vehicles = data;
            this.$vs.loading.close();
          })
          .catch(e => {
            this.showError(e);
          });
      }
    },
    cancelBook() {
      this.vehicleBook = false;
      (this.configFromdateTimePicker.maxDate = null),
        (this.configTodateTimePicker.minDate = null),
        (this.office_id = null);
      this.from_date = null;
      this.start_time = null;
      this.end_date = null;
      this.end_time = null;
      this.availableVehicle = [];
    },
    // ===== Confirm Delete =====
    confirmBook(id) {
      this.vehicleID = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to book this vehicle?",
        acceptText: "Book",
        accept: this.bookVehicle
      });
    },
    // ===== Delete User =====
    deleteUser() {
      let input = {
        data: {
          id: this.deleteIndex
        }
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .delete("user/deleteUser", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "Vehicle booked successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.getusers();
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
    },
    bookVehicle(vehicle_id) {
      let input = {
        vehical_id: this.vehicleID,
        from_date: this.from_date,
        from_time: this.start_time,
        to_date: this.end_date,
        to_time: this.end_time
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .post("vehicalBooking", input)
        .then(response => {
          this.button_loader(false, "#vehicle-addupdate");
          let text = "Vehicle booked successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.vehicleBook = false;
          (this.configFromdateTimePicker.maxDate = null),
            (this.configTodateTimePicker.minDate = null),
            (this.office_id = null);
          this.from_date = null;
          this.start_time = null;
          this.end_date = null;
          this.end_time = null;
          this.vehicleID = null;
          this.availableVehicle = [];
          this.$vs.loading.close();
          this.vehiclebookedByme();
          this.tabvalue = 0;
        })
        .catch(e => {
          this.showError(e, "#vehicle-addupdate");
        });
    },
    searchVehicle() {
      this.$validator.validateAll("book-form").then(result => {
        if (result) {
          if (this.from_date == this.end_date) {
            if (this.endTimeCheck() == false) {
              return;
            }
          }
          this.$vs.loading({ color: "primary" });
          let input = {
            office_id: this.office_id,
            from_date: this.from_date,
            from_time: this.start_time,
            to_date: this.end_date,
            to_time: this.end_time
          };
          let url = "vehicalBooking";
          this.axios
            .get(url, { params: input })
            .then(response => {
              let data = response.data.data;
              this.$vs.loading.close();
              if (data.length == 0) {
                this.$vs.notify({
                  text: "Vehicles are not available.",
                  color: "danger",
                  position: "top-right"
                });
                return;
              }
              this.availableVehicle = data;
            })
            .catch(e => {
              this.showError(e);
            });
        }
      });
    },
    onFromChange(selectedDates, dateStr, instance) {
      console.log("dateStr", dateStr);
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
      this.end_date = dateStr;
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    vehiclebookedByme() {
      let url = "vehicalBooked";
      let input = {
        office_id: this.filter_office_id,
      };
      this.axios
        .get(url,{ params: input })
        .then(response => {
          let data = response.data.data;
          this.booked = data.responseData;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getOffice() {
      this.$vs.loading({ color: "primary" });

      let url = "office/getAll";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.offices = data;
          this.$vs.loading.close();
          this.office_id = this.$store.state.uInfo.office_id;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getVechicle() {
      this.$vs.loading({ color: "primary" });

      let url = "vehicals";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.vehicles = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    unbook(index) {
      this.deleteIndex = index;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to unbook this vehicle?",
        acceptText: "Sure",
        accept: this.unBookVehicle
      });
    },
    unBookVehicle() {
      let input = {
        data: {
          id: this.deleteIndex
        }
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .delete("vehicalBooking", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "Vehicle unbooked successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.vehiclebookedByme();
          this.tabvalue = 0;
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
    },
    editVehicle(vehicle) {
      this.vehicle_id = vehicle.vehical_id ? vehicle.vehical_id : null;
      this.is_disabled = vehicle.vehical_id ? true : false;
      this.show_v_type = vehicle.vehical_id ? false : true;
      this.vehicleAddEdit = true;
      this.vehicleIndex = vehicle.id;
      this.office_id = vehicle.office_id.id;
      this.name = vehicle.name;
      this.brand = vehicle.brand;
      this.starting_kms = vehicle.starting_km;
      this.vehicle_number = vehicle.number;
      this.year = vehicle.year;
      this.type = vehicle.type;
      this.colour = vehicle.colour;
      this.service_due_date = vehicle.service_due_date;
      this.rego_next_date = vehicle.rego_next_date;
      this.status = vehicle.status;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    viewVehicle(vehicle) {
      this.vehicle_id = vehicle.vehical_id;
      this.vehicleAddEdit = true;
      this.vehicleIndex = vehicle.id;
      this.office_id = vehicle.office_id.id;
      this.name = vehicle.name;
      this.brand = vehicle.brand;
      this.starting_kms = vehicle.starting_km;
      this.vehicle_number = vehicle.number;
      this.year = vehicle.year;
      this.type = vehicle.type;
      this.colour = vehicle.colour;
      this.service_due_date = vehicle.service_due_date;
      this.rego_next_date = vehicle.rego_next_date;
      this.status = vehicle.status;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
  }
};
</script>
<style>
.code-border {
  border: 1px solid;
}
.minus-top {
  margin-top: -58px;
}

.selectAll .input-select-con {
  margin-bottom: 15px;
}
.size {
  height: 25px;
}
.rsize {
  height: 50px;
  width: 60px;
}
.vehicle-type .vx-col {
  padding: 0 0rem;
}
.radio {
  width: auto !important;
}
.pad0 {
  padding: 0 !important;
}
.padr0 {
  padding-right: 0 !important;
}
.r_align {
  align-items: baseline !important;
}
</style>

		